export const CUSTOM_TL_CONTROL_ID = 'custom-tl-control';
